import { useQuery } from '@tanstack/react-query';
import useIonicToast from '../../../hooks/useIonicToast';
import { getProductsInventory } from '../getProductsInventory';
import { getInventoryAnalytics } from '../getInventoryAnalytics';
import dayjs from 'dayjs';

type Props = {
  authToken?: string;
  storeId?: number;
  currentPage?: number;
  target?: 'both' | 'inventory' | 'metrics';
};
export default function useStoreInventoryService({
  authToken,
  storeId,
  currentPage = 1,
  target = 'both',
}: Props) {
  const { presentIonToast } = useIonicToast();
  const now = dayjs().utc();
  const from_date = now.subtract(1, 'month').toString();
  const to_date = now.toString();

  //FETCHING INVENTORY
  const inventory = useQuery({
    queryKey: ['products-inventory', currentPage],
    queryFn: async () => {
      try {
        if (!storeId || !authToken) return;
        const res = await getProductsInventory(storeId, authToken, {
          page: currentPage.toString(),
          limit: '20',
          from_date,
          to_date,
        });
        return res;
      } catch (error: any) {
        presentIonToast(error.message, 'error');
      }
    },
    enabled:
      Boolean(authToken) &&
      Boolean(storeId) &&
      (target == 'both' || target == 'inventory'),
  });

  //FETCHING INVENTORY METRICS
  const metrics = useQuery({
    queryKey: ['products-metrics'],
    queryFn: async () => {
      try {
        if (!storeId || !authToken) return;
        return await getInventoryAnalytics(storeId, authToken, {
          from_date,
          to_date,
        });
      } catch (error: any) {
        presentIonToast(error.message, 'error');
      }
    },
    refetchInterval: 60000,
    enabled:
      Boolean(authToken) &&
      Boolean(storeId) &&
      (target == 'both' || target == 'metrics'),
  });

  return {
    inventory,
    metrics,
  };
}
